<template>
  <div
    class="modal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"
    v-bind:class="{ 'show fade bg-shadow': visible }"
    :style="visible ? 'display:block;' : ''"
  >
    <div class="modal-dialog modal-dialog-scrollable">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title"><b>Retirar saldo de TreidBlue</b></h5>
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
            @click="handleCloseModal"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body mt-4 modal-container">
          <p class="mt-2 alert alert-warning text-center">
            Este retiro será pagado 1 a 3 días hábiles posterior a las fechas de
            corte 15 y 30, llegará directo a su cuenta destino y no es necesario
            pagar calificación.<br /><br />El sacoin será pagado de acuerdo a
            nuestro tipo de cambio y podrán aplican comisiones administrativas
            por retiros.
          </p>
          <p>Monto a retirar (Maximo SC${{ maxPayment.toFixed(2) }})</p>
          <input
            type="number"
            class="form-control"
            v-model="input.payment"
            placeholder="Monto a retirar"
            aria-describedby="emailHelp"
            v-on:input="handleChangePayment"
          />
          <p class="mt-4">
            Método de retiro: <b>{{ metodo }}</b>
          </p>
          <p v-for="(dato, campo) in datosRetiros" :key="dato">
            {{ campo }}: <b>{{ dato }}</b>
          </p>
          <div class="alert alert-secondary mt-2">
            <p class="card-text text-center"><b>Tipo de cambio: </b></p>

            <p class="text-left text-underline">
              <b>&#x1f1fa;&#x1f1f2; Cambio USD:</b>
            </p>
            <p>- Sacoin a la compra: {{ dolarPrice["USA-Compra"] }}</p>
            <p class="text-left text-underline">
              <b>&#x1F1E8;&#x1F1F4; Cambio Colombia:</b>
            </p>
            <p>- Sacoin a la compra: {{ dolarPrice["COP-Compra"] }}</p>
            <p class="text-left text-underline">
              <b>&#x1F1F2;&#x1F1FD; Cambio México:</b>
            </p>
            <p>- Sacoin a la compra: {{ dolarPrice["MXN-Compra"] }}</p>
            <p class="text-left text-underline">
              <b>&#x1F1E6;&#x1F1F7; Cambio Argentina:</b>
            </p>
            <p>- Sacoin a la compra: {{ dolarPrice["ARG-Compra"] }}</p>
            <p class="text-left text-underline">
              <b>&#x1F1E8;&#x1F1F1; Cambio Chile:</b>
            </p>
            <p>- Sacoin a la compra: {{ dolarPrice["CLP-Compra"] }}</p>
            <p class="text-left text-underline">
              <b>&#x1F1F5;&#x1F1EA; Cambio Perú:</b>
            </p>
            <p>- Sacoin a la compra: {{ dolarPrice["PEN-Compra"] }}</p>
            <p class="text-left text-underline">
              <b>&#x1f1e7;&#x1f1f4; Cambio Bolivia:</b>
            </p>
            <p>- Sacoin a la compra: {{ dolarPrice["BOB-Compra"] }}</p>
            <p class="text-left text-underline">
              <b>&#x1f1ea;&#x1f1fa; Cambio Euro:</b>
            </p>
            <p>- Sacoin a la compra: {{ dolarPrice["EUR-Compra"] }}</p>
          </div>
        </div>

        <p class="text-danger text-center w-100 mt-4 mb-0">{{ apiError }}</p>
        <div class="p-3 d-flex justify-content-between">
          <span class="btn btn-secondary mr-2" @click="handleCloseModal"
            >Volver</span
          >
          <span
            class="btn btn-treid"
            @click="handleClickSend"
            :class="onLoad ? 'd-none' : ''"
            >Retirar</span
          >
          <span
            class="btn btn-treid align-items-center"
            :class="onLoad ? 'd-flex' : 'd-none'"
          >
            <span
              class="spinner-border spinner-border-sm"
              role="status"
              aria-hidden="true"
            ></span>
            <span class="pl-2">Retirando...</span>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Api from "../../tools/Api2";

export default {
  name: "ModalRetirePayment",
  props: {
    visible: Boolean,
    maxPayment: Number,
  },
  data() {
    return {
      onLoad: false,
      input: {
        payment: 0,
      },
      apiError: "",
      datosRetiros: [],
      metodo: "Cargando...",
      dolarPrice: [],
    };
  },
  methods: {
    handleChangePayment() {
      if (this.input.payment > this.maxPayment)
        this.input.payment = this.maxPayment.toFixed(2);
      if (this.input.payment < 0) this.input.payment = 0;
    },
    handleCloseModal() {
      this.$emit("close");
    },
    handleClickSend() {
      this.apiError = "";
      if (this.input.payment <= 0) {
        this.apiError = "Por favor, seleccione un monto a retirar";
        return;
      }
      if (["No seleccionado"].includes(this.metodo)) {
        this.apiError = "Por favor, seleccione un metodo de retiro";
        return;
      }

      if (["Cargando..."].includes(this.metodo)) {
        return;
      }

      this.onLoad = true;
      Api("transaction")
        .post({
          payment: this.input.payment,
          metodo: this.metodo,
          props: this.datosRetiros,
          name: "DEFAULT_RETIRE",
        })
        .then(() => {
          this.onLoad = false;
          this.$emit("trasnfer", {
            payment: this.input.payment,
            metodo: this.metodo,
            success: true,
          });
        });
    },
  },
  created: function () {
    Api("sistem-apple")
      .get("modo-retiro")
      .then((res) => {
        this.metodo = res.metodo;
        this.datosRetiros = res.datos_retiro ? res.datos_retiro : [];
      });

    Api("tipo-cambio")
      .get()
      .then((res) => {
        this.dolarPrice = res.changes;
      });
  },
};
</script>
<style lang="css" scoped>
.modal-container {
  overflow-y: auto;
  max-height: 600px !important;
  height: 600px;
}

.w-75 {
  width: 75%;
}
</style>